import {createContext, useContext} from "react";
import {KatalkController} from "../../controller/katalk-controller";

export const KatalkControllerContext = createContext<KatalkController|undefined>(undefined);

export const useKatalkControllerContext = () => useContext(KatalkControllerContext);